/**
 * ZIvapp user — the app-wide shape, whatever backend produced it.
 *
 * @typedef {object} User
 * @property {string}      id           Firebase uid, or users.id in MySQL
 * @property {string}      phone        E.164, e.g. +2348000000001
 * @property {string}      displayName
 * @property {string}      about        The status line on the profile
 * @property {string|null} avatarUrl
 * @property {boolean}     isOnline
 * @property {Date|null}   lastSeen
 * @property {Date}        createdAt
 */

import { toDate } from '../utils/time.js'

/**
 * Normalise a raw record from any provider into a User.
 * Keeps Firestore Timestamps and ISO strings out of the components.
 *
 * @param {string} id
 * @param {object} raw
 * @returns {User}
 */
export function toUser(id, raw = {}) {
  return {
    id,
    phone:       raw.phone ?? '',
    displayName: raw.displayName ?? raw.display_name ?? '',
    about:       raw.about ?? '',
    avatarUrl:   raw.avatarUrl ?? raw.avatar_url ?? null,
    isOnline:    Boolean(raw.isOnline ?? raw.is_online ?? false),
    lastSeen:    toDate(raw.lastSeen ?? raw.last_seen),
    createdAt:   toDate(raw.createdAt ?? raw.created_at) ?? new Date()
  }
}

/** Fields a client is allowed to write to its own profile. */
export const EDITABLE_USER_FIELDS = ['displayName', 'about', 'avatarUrl']
